<template>
  <div class="empty">
    <v-icon x-large>
      mdi-block-helper
    </v-icon>
    <p>{{emptyText}}</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyTable',
  props: {
    emptyText: {
      type: String,
      required: true,
      default: 'В таблице нет элементов'
    }
  }
}
</script>

<style scoped>
  .empty {
    text-align: center;
    padding: 5% 0 5% 0;
  }
</style>
